<template>
  <svg width="18"
       height="18"
       viewBox="0 0 18 18"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M13.3594 10.8076V1.97461C13.3594 1.31543 12.876 0.788086 12.1992 0.788086C11.751 0.788086 11.4346 0.981445 10.9512 1.43848L7.54102 4.59375C7.50586 4.62891 7.46191 4.65527 7.41797 4.65527H7.19824L13.3594 10.8076ZM16.4355 17.3818C16.708 17.6455 17.1562 17.6543 17.4199 17.3818C17.6924 17.1006 17.6924 16.6611 17.4199 16.3887L2.02148 0.999023C1.74902 0.726562 1.30078 0.717773 1.01953 0.999023C0.755859 1.2627 0.755859 1.71973 1.01953 1.9834L16.4355 17.3818ZM4.54395 12.3896H7.02246C7.10156 12.3896 7.17188 12.416 7.22461 12.4688L10.9512 15.9316C11.3906 16.3535 11.7598 16.5381 12.208 16.5381C12.7178 16.5381 13.1045 16.2744 13.2803 15.7559L3.04102 5.52539C2.74219 5.85938 2.58398 6.35156 2.58398 7.00195V10.3418C2.58398 11.7129 3.25195 12.3896 4.54395 12.3896Z"
          :fill="color"/>
  </svg>

</template>
<script>
export default {
  name: 'SalesIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>
